<template>
  <div>
    {{ ActDescBtn }}
    <table
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
      style="position: absolute"
      width="100%"
    >
      <tr height="48px" max-height="48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Imprime Existencias y Ventas por Proveedor'"
          :titulo="'Reporte Existencias y Ventas por Proveedor'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="">
                      <i class="fa fa-eye" style="font-size: 25px"></i>
                      ver
                    </v-btn>
                    <v-btn
                      color="deep-purple accent-2"
                      dark
                      small
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                    >
                      <i class="fa fa-print" style="font-size: 25px"></i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
                  :url="
                    $hostname + $hName + '/services/tipocliente/findalltipoclientes'
                  "
                  :nombre="'Tipo de Clientes'"
                  :headers="headers"
                  :slotname="'item.descripcion'"
                  :emitnombre="'emitReporteExistenciasVentas'"
                  :SeachNombre="'Búsqueda por descripcion '"
                  :slotlist="slotlist"
                /> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>

                  <span class="font-weight-light" style="font-size: 20px">
                    Impresion de Existencias y Ventas por Proveedor
                  </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
                    color="grey darken-4"
                    fab
                    small
                    @click="cerrarmodalcuenta"
                  >
                   <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
                  </v-btn> -->
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field
                          v-model="ExistenciasVentas.desde"
                          :rules="[$rules.required]"
                          dense
                          label="Desde:"
                          outlined
                          type="date"
                          @blur="BlurDesde"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!-------------------------------------------------- proveedor :rules="[$rules.required]" -->
                        <v-combobox
                          v-model="ExistenciasVentas.provee"
                          :items="Rproveedor"
                          
                          autocomplete="off"
                          dense
                          item-text="nombre"
                          label=" * Proveedor:"
                          outlined
                          @blur="SelctCbProveedor"
                          @focus="cargarProveedor"
                          @keyup="CbFilProveedor"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  Hasta  -->
                        <v-text-field
                          v-model="ExistenciasVentas.hasta"
                          :rules="[$rules.required]"
                          dense
                          label="Hasta:"
                          outlined
                          type="date"
                          @blur="BlurHasta"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                        <!-- :rules="[$rules.required]" -->
                        <v-combobox
                          v-model="ExistenciasVentas.almacen"
                          :items="Ralmacen"
                          autocomplete="off"
                          dense
                          item-text="descripcion"
                          label=" * Almacén"
                          outlined
                          @blur="SelctCbAlmacen"
                          @focus="CargarRalmacen"
                        >
                          <template v-slot:prepend>
                            <v-img height="20px" src="../../assets/warehouse.png" width="20px"></v-img>
                          </template>
                        </v-combobox>
                      </v-col>
                      <!-- fn columna 2 -->

                      <!-- radios + switch (dentro del form; switch fuera de la caja de movimiento) -->
                      <v-col cols="12" md="6" sm="6" class="py-1">
                        <div style="border: 1px solid #000000;">
                          <center>
                            <span style="font-size: 12px"><b>MOVIMIENTO (COMPRA Y VENTA):</b></span>
                            <v-radio-group
                              dense
                              hide-details
                              class="pt-0 mt-0 d-flex justify-center"
                              v-model="ExistenciasVentas.producMovimOpc"
                              row
                            >
                              <v-radio label="" color="green" :value="1">
                                <template v-slot:label>
                                  <strong style="color: #000000; font-size: 11px">TODOS</strong>
                                </template>
                              </v-radio>
                              <v-radio label="" color="green" :value="2">
                                <template v-slot:label>
                                  <strong style="color: #000000; font-size: 11px">CON MOVIMIENTO</strong>
                                </template>
                              </v-radio>
                              <v-radio label="" color="green" :value="3">
                                <template v-slot:label>
                                  <strong style="color: #000000; font-size: 11px">SIN MOVIMIENTO</strong>
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </center>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" sm="6" class="py-1 d-flex align-center">
                        <v-switch
                          class="mt-0 pt-0"
                          color="teal"
                          hide-details
                          label=""
                          v-model="ExistenciasVentas.ordenAscDesc"
                        >
                          <template v-slot:label>
                            <strong
                              v-if="ExistenciasVentas.ordenAscDesc == true"
                              style="color:#000000; font-size:13px;"
                            >Ordenar código: menor a mayor.</strong>
                            <strong
                              v-if="ExistenciasVentas.ordenAscDesc == false"
                              style="color:#000000; font-size:13px;"
                            >Ordenar código: normal.</strong>
                          </template>
                        </v-switch>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>

                <hr />

                <ModalReporteFiltros
                  ref="ModRepFilt"
                  :Datos="ExistenciasVentas"
                  @DataReporteBasico="DDataReporteBasico"
                />
              </v-card>
            </v-container>
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <!--
                    <BarraBusqueda2
                          :url="$hostname + $hName + '/services/caja/findAll'"
                          :nombre="'Cajas'"
                          :headers="headers"
                          :slotname="'item.descripcion'"
                          :emitnombre="'emitCaja'"
                          :slotlist="slotlist"
                          :SeachNombre="'Búsqueda por descripción caja'"
                        /> -->
          </div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros2"
  import {
    currencyFormatter,
    fechaNueva,
    FormatoFecha,
    getParamFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoBasico,
    RedondeoValor,
    RedondeoValorCantRed,
  } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },
    created() {
      var json = {
        titulo: "Reporte Depósito Facturas al Cobro",
        descripcion: "Imprime las Facturas Pendientes por Cobrar de Clientes.",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
      }
      EventBus.$emit("anularBotonesAccion", json)
    },
    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)

      // EventBus.$on("emitReporteExistenciasVentas", this.datostabla);
      EventBus.$on("onResize", this.onResize)
      this.$refs.ModRepFilt.CrearObjecto = this.validarObjecto
    },

    data: () => ({
      Rproveedor: [],
      Ralmacen: [],
      windowSize: { width: "auto", height: "auto" },
      ExistenciasVentas: {
        nombre: " Existencias y Ventas por Proveedor",
        UrlImprimir: "/reportesCXP/ImprimirExistenciasVentasProveedor",
        UrlExel: "/reportesCXP/ExcelExistenciasVentasProveedor",
        UrlCorreo: "/reportesCXP/CorreoExistenciasVentasProveedor",
        desde: fechaNueva(),
        hasta: fechaNueva(),
        provee: null,
        almacen: null,
        producMovimOpc: 1,
        ordenAscDesc: false,

        //fechaCreacion: new,
        //  fechaModificacion: "",
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,

      aalert: {
        estado: false,
        color: null,
      },
    }),

    //   destroyed() {
    //     location.reload();
    //   },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      HoraFormatter2,
      RedondeoValor,
      RedondeoBasico,
      RedondeoValorCantRed,
      fechaNueva,
      getParamFecha,
      onResize(e) {
        //this.windowSize=e
      },

      validarObjecto() {
        if (!this.$refs.form.validate()) {
          this.$refs.ModRepFilt.detener = true
          return
        } else {
          this.$refs.ModRepFilt.detener = false
        }

        //this.ExistenciasVentas.where = "f.fecha >='" + this.ExistenciasVentas.desde + "' and f.fecha<='" + this.ExistenciasVentas.hasta + "' ";

        var where = " p.codigo > 0 and p.activo=true "
        var where2=""

        var codProve = ` pv.codigo > 0 `
        if (this.ExistenciasVentas.provee != null) {
          where += " and pro.codigo=" + this.ExistenciasVentas.provee.codigo
          this.ExistenciasVentas.proveedor = this.ExistenciasVentas.provee.nombre
          codProve= ` pv.codigo = ${this.ExistenciasVentas.provee.codigo} `
        }

        var codalm = 0
        if (this.ExistenciasVentas.almacen != null) {
          where += " and b.almacen = " + this.ExistenciasVentas.almacen.codigo
          codalm = this.ExistenciasVentas.almacen.codigo
        }

        if(this.ExistenciasVentas.producMovimOpc==2){
          where2= `HAVING MAX(venta)>0 OR MAX(compra)>0`
        }

        if(this.ExistenciasVentas.producMovimOpc==3){
          where2= `HAVING MAX(venta)=0 AND MAX(compra)=0`
        }

        this.ExistenciasVentas.where = where
        this.ExistenciasVentas.cod_proveedor = codProve
        this.ExistenciasVentas.codalm = codalm
        var usarLote =this.$store.getters.GetConfiguracionGeneral.configInv.usarLote
        this.ExistenciasVentas.usarLote  = usarLote!=null?usarLote:false 
        this.ExistenciasVentas.where2=where2

        
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },

      datostabla(e) {},
      save() {},
      remove() {},
      eliminar() {},
      anular() {},
      imprimirList() {},
      DDataReporteBasico() {},
      newwnuevo() {
        ;(this.ExistenciasVentas = {
          desde: fechaNueva(),
          hasta: fechaNueva(),
          proveedor: null,
          almacen: null,
        }),
          EventBus.$emit("actualizaBarraBusqueda2")
      },

      BlurDesde() {
        if (this.ExistenciasVentas.desde.toString().length == 0) {
          this.ExistenciasVentas.desde = this.fechaNueva()
        }
      },

      BlurHasta() {
        if (this.ExistenciasVentas.hasta.toString().length == 0) {
          this.ExistenciasVentas.hasta = this.fechaNueva()
        }
      },

      cargarProveedor() {
        this.$axios
          .get(this.$hostname + this.$hName + "/proveedores/findallbyDesc/25/0/*", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.Rproveedor = res.data))
      },

      SelctCbProveedor() {
        var _this = this
        setTimeout(function () {
          if (_this.ExistenciasVentas.provee == null) {
            _this.ExistenciasVentas.provee = ""
          }

          if (!_this.ExistenciasVentas.provee.hasOwnProperty("codigo")) {
            _this.ExistenciasVentas.provee = ""
            _this.ExistenciasVentas.provee = null
            return
          }
        }, 300)
      },

      CbFilProveedor(e) {
        if (e.target.value.length >= 0) {
          this.$axios
            .get(
              this.$hostname +
                this.$hName +
                "/proveedores/findallbyDesc/25/0/" +
                (e.target.value === "" ? "*" : e.target.value),
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => (this.Rproveedor = res.data))
        }
      },

      CargarRalmacen() {
        this.$axios
          .get(this.$hostname + this.$hName + "/almacen/activos", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => {
            this.Ralmacen = res.data
          })
      },

      SelctCbAlmacen() {
        var _this = this
        setTimeout(function () {
          if (_this.ExistenciasVentas.almacen == null) {
            _this.ExistenciasVentas.almacen = ""
          }

          if (!_this.ExistenciasVentas.almacen.hasOwnProperty("codigo")) {
            _this.ExistenciasVentas.almacen = ""
            _this.ExistenciasVentas.almacen = null
            return
          }
        }, 300)
      },

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

          this.newwnuevo()
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = false
        }
      },
    },

    computed: {
      ActDescBtn() {
        this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
        //EventBus.$emit("ActDesaBotones", objjct);
      },
    },
  }
</script>

<style></style>
